import React from "react";
import { Box, Typography } from "@mui/material";
import useCommon from "../../hooks/useCommon";
import { useFormHeader } from "../../contexts/FormHeaderContext";

export default function ContentContainer({ children }) {
  const { containerTitle, containerTitleDescription } = useCommon();
  const { formHeader } = useFormHeader();
  return (
    <Box sx={{ minWidth: 0 }}>
      {!formHeader && containerTitle && <Box sx={{ mb: 3 }}>
        <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 700, letterSpacing: 1.5 }}>Workspace</Typography>
        <Typography component="h1" variant="h4" sx={{ fontSize: { xs: 25, md: 30 }, fontWeight: 750, letterSpacing: "-.035em", color: "text.primary", mb: 1 }}>{containerTitle}</Typography>
        {containerTitleDescription && <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 760, lineHeight: 1.7 }}>{containerTitleDescription}</Typography>}
      </Box>}
      <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
